import React from 'react';
import {injectStripe} from 'react-stripe-elements';
import CardSection from './CardSection';
import Button from 'material-ui/Button';

const styles = {
  confirmButton: {
    margin: '20px auto 0 auto',
    display: 'table',
    fontWeight: 'normal',
    color: '#44BED2'
  },
  error: {
    color: 'red',
    fontSize: 'smaller',
    textAlign: 'center',
    paddingTop: '10px'
  }
}
class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      error: false,
      processing: false
    };
  }

  handleSubmit = (ev) => {
    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();

    this.setState({
      error: false,
      processing: true
    });

    var self = this;
    this.props.onPayed().then(function() {
      // Within the context of `Elements`, this call to createToken knows which Element to
      // tokenize, since there's only one in this group.
      self.props.stripe.createToken({name: self.props.name || 'No name'}).then(async ({token}) => {
        if (token === undefined) {
          self.setState({
            error: true,
            processing: false,
            success: false
          });
        } else {
          // Pass the received token to our Firebase function
          let res = await self.charge(token, 100, 'CAD');
          if (res.body.error) {
            console.error('Problem charing the card: ', res.body.error);
            self.setState({
              error: true,
              processing: false,
              success: false
            });
          } else {
            // Card successfully charged
            self.setState({
              error: false,
              processing: false,
              success: true
            });

            // Add payment info to order
            self.props.onPayedSuccess(res.body);
          }
        }
      });
    }).catch(function(e) {
      console.error('Charge error:', e)
      self.setState({
        error: true,
        processing: false,
        success: false
      });
    });

  }
  
  async charge(token, amount, currency) {
    const FIREBASE_FUNCTION = 'https://us-central1-tilesbyjoe.cloudfunctions.net/charge/';
    const res = await fetch(FIREBASE_FUNCTION, {
      method: 'POST',
      body: JSON.stringify({
          token,
          charge: {
              amount,
              currency,
          },
      }),
    });
    const data = await res.json();
    data.body = JSON.parse(data.body);
    return data;
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <CardSection/>
        <Button color="primary" disabled={!!this.state.processing || !!this.state.success} style={styles.confirmButton} onClick={this.handleSubmit}>
          {!!this.state.processing && 'Processing...'}
          {!this.state.processing && !this.state.success && 'Confirm'}
          {!this.state.processing && !!this.state.success && 'Sucessfully charged!'}
        </Button>
        {!!this.state.error &&
          <div style={styles.error}>Wrong credit card information</div>
        }
      </form>
    );
  }
}

export default injectStripe(CheckoutForm);


// WEBPACK FOOTER //
// ./src/CheckoutForm.js